// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_property_broadcasts_edges_node_activityReport(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["ActivityReportV5"]);
}

function unwrap_fragment_property_status(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "ActiveProperty",
              "ExpiredProperty",
              "SoldProperty",
              "UnderContractProperty",
              "WithdrawnProperty"
            ]);
}

var fragmentConverter = {"__root":{"property_status":{"u":"fragment_property_status"},"property_broadcasts_edges_node_activityReport":{"u":"fragment_property_broadcasts_edges_node_activityReport"},"":{"f":""}}};

var fragmentConverterMap = {
  fragment_property_broadcasts_edges_node_activityReport: unwrap_fragment_property_broadcasts_edges_node_activityReport,
  fragment_property_status: unwrap_fragment_property_status
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function forSalePropertyMatchingType_decode($$enum) {
  if ($$enum === "QUIET" || $$enum === "ONE_WAY" || $$enum === "BROADCAST" || $$enum === "QUIET_ANONYMOUS") {
    return $$enum;
  }
  
}

function forSalePropertyMatchingType_fromString(str) {
  return forSalePropertyMatchingType_decode(str);
}

var Utils = {
  forSalePropertyMatchingType_decode: forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: forSalePropertyMatchingType_fromString
};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "archived",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MyClientsWidgetSeller_Menu_seller",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "ForSalePropertyV5",
        "kind": "LinkedField",
        "name": "property",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": "forSaleMatchingType",
              "args": null,
              "kind": "ScalarField",
              "name": "matchingType",
              "storageKey": null
            },
            "action": "THROW"
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "ExpiredProperty",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isRenewable",
                      "storageKey": null
                    }
                  ],
                  "type": "ActiveProperty",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "SoldProperty",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "UnderContractProperty",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "WithdrawnProperty",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            "action": "THROW"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "dismissalState",
                "value": "UNDISMISSED"
              }
            ],
            "concreteType": "ForSalePropertyMatchConnection",
            "kind": "LinkedField",
            "name": "matches",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              }
            ],
            "storageKey": "matches(dismissalState:\"UNDISMISSED\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "PropertyBroadcastConnection",
            "kind": "LinkedField",
            "name": "broadcasts",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "PropertyBroadcastEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": "ForSalePropertyBroadcast",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "activityReport",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    (v1/*: any*/)
                                  ],
                                  "type": "ActivityReportV5",
                                  "abstractKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            "action": "NONE"
                          }
                        ],
                        "storageKey": null
                      },
                      "action": "NONE"
                    }
                  ],
                  "storageKey": null
                },
                "action": "NONE"
              }
            ],
            "storageKey": "broadcasts(first:1)"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MyClientsWidgetDeleteDialog_clientV5"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
})());

var wrap_fragment_property_broadcasts_edges_node_activityReport = RescriptRelay_Internal.wrapUnion;

var wrap_fragment_property_status = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_property_broadcasts_edges_node_activityReport = unwrap_fragment_property_broadcasts_edges_node_activityReport;
exports.wrap_fragment_property_broadcasts_edges_node_activityReport = wrap_fragment_property_broadcasts_edges_node_activityReport;
exports.unwrap_fragment_property_status = unwrap_fragment_property_status;
exports.wrap_fragment_property_status = wrap_fragment_property_status;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
